import { render, staticRenderFns } from "./MonthsEstablishmentSettingDelete.vue?vue&type=template&id=5467bda5&scoped=true&"
import script from "./MonthsEstablishmentSettingDelete.vue?vue&type=script&lang=js&"
export * from "./MonthsEstablishmentSettingDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5467bda5",
  null
  
)

export default component.exports